<template>
  <v-container class="ma-0 pa-0 mw-100">
    <v-container class="ma-0 pa-0 mw-100" :class="`text-${$vuetify.breakpoint.name}-h2` + ' pb-2'">{{ title }}</v-container>
    <v-container class="ma-0 pa-0 mw-100"
      id="divider"
      style="background-color: rgb(150, 150, 150); height: 1px; width: 100%"
    ></v-container>
    <custom-progressbar :loading="loadingState"></custom-progressbar>
  </v-container>
</template>

<script>
/**
 * @vue-prop {String} title - title content
 */
import CustomProgressbar from "../../layout/CustomProgressbar";

export default {
  name: "TitleBig",
  components: {
    CustomProgressbar,
  },
  props: {
    title: String,
  },
  computed: {
    loadingState() {
      return this.$store.state.loading;
    },
  },
};
</script>